(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .service('Filters', Filters);

  function Filters($stateParams, StandardReportFilter, DateUtil) {

    /**
     * filter object for displaying filters
     *
     *
     * Methods: {
        getFilter : To get filters all including dimensions,
        resetFilter : to reset selected filters,
        getFilterParams: method to get consumer filter params @Output: {queryParams, pathParams},
        setFilter: Method to be called to apply the changes in transientFilter,
        createFilter: Method to be called on controller
      }
     *
     * */

    var filter = {};

    return {
      getFilter: getFilter,
      resetFilter: resetFilter,
      getFilterParams: getFilterParams,
      setFilter: setFilter,
      createFilter: createFilter,
      getRegion: getRegion,
      getDeviceTypes: getDeviceTypes,
      getHierarchy: getHierarchyParams
    };

    function createFilter(filterObj, filterStateParams){
      filter = StandardReportFilter(filterObj, filterStateParams);
      return getFilter();
    }

    function setFilter(formFilterObj) {
      filter = formFilterObj;
    }

    function getFilter(){
      return angular.copy(filter);
    }

    function resetFilter(){
      filter = filter.reset();
      return getFilter();
    }


    function getFilterParams(){
      var selectedDevices = (filter.deviceType) ? getDeviceTypeParams(getSelected(filter.deviceType).value()) : [],
          selectedContinents = [],
          selectedCountries = [],
          selectedUILocales = [],
          selectedHierarchy = {};

      if(!_.isEmpty(filter.region)){
        selectedContinents = getSelectedRegionParams(filter.region, 0);
        selectedCountries = getSelectedRegionParams(filter.region, 1);
        selectedUILocales = getSelectedRegionParams(filter.region, 2);
      }
      if(!_.isEmpty(filter.hierarchy)){
        selectedHierarchy = getHierarchyParams(filter);
      }


      var pathParams = {detailLevel: _.lowerCase(_.head(getValues(getSelected(filter.detailLevel))))};
      var queryParams = _.merge({startDate: DateUtil.formatToYearMonthDay(filter.dateRange.startDate)},
          {endDate: DateUtil.formatToYearMonthDay(filter.dateRange.endDate)},
          {deviceType: selectedDevices},
          {country: selectedCountries},
          {uiLocale: selectedUILocales},
          {continent: selectedContinents},
          selectedHierarchy,
          filter.dashboardSpecificParams);

      return _.merge({queryParams: queryParams}, {pathParams: pathParams});
    }

    function comparisonMetricParams(filter) {
      if(!_.isUndefined(filter.metric)) {
        return { comparisonMetric: filter.metric }
      }
    }

    function getHierarchyParams() {
      var departments = filter.addressable ? filter.addressableHierarchy : filter.hierarchy;
      var hierarchy = _.head(getSelected(departments).value());
      var category = _.head(getSelected(hierarchy.values).value());
      return {
        department: hierarchy.name,
        category: category.name,
        classification: _.head(getSelected(category.values).value()).name
      }
    }

    function getValues(arr){
      return _(arr).map(function(o){return o.name}).value();
    }

    function getDeviceTypeParams(deviceTypes) {
      return _.flatMap(deviceTypes, function (deviceType) {
        return deviceType.values.length > 0 ? _.map(getSelected(deviceType.values).value(), function (subDeviceType) {
          return deviceType.name + "_" + subDeviceType.name;
        }) : deviceType.name;
      });
    }

    function getRegionParams(region, hierarchyLevel) {
      if(hierarchyLevel > 0) {
        var regionValues = _.flatMap(region, 'values');
        return getRegionParams(regionValues, hierarchyLevel - 1);
      }
      else
        return region;
    }

    function getSelectedRegionParams(region, hierarchyLevel) {
      var regionParams = getRegionParams(region, hierarchyLevel);
      return getValues(getSelected(regionParams));
    }

    function getSelected(arr){
      return _(arr).filter({isSelected: true});
    }

    function getRegion(hierarchyLevel) {
      return getRegionParams(filter.region, hierarchyLevel);
    }

    function getDeviceTypes() {
      return getDeviceTypeParams(filter.deviceType);
    }


  }


})();